import React, { useState } from 'react';

const ChevronDownIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m6 9 6 6 6-6" />
  </svg>
);

function FaqAccordion({ items }) {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    
    <div className="containers-min mx-auto rounded-2xl border border-black/10 divide-y divide-black/10 overflow-hidden">
      {items.map((item, i) => {
        const isOpen = openIndex === i;
        return (
          <div key={item.q}>
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : i)}
              aria-expanded={isOpen}
              className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 font-gilroy font-bold text-black/80 hover:bg-black/[0.02] transition-colors"
            >
              <span>{item.q}</span>
              <ChevronDownIcon
                className={`w-5 h-5 shrink-0 text-[rgb(35,180,85)] transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
              />
            </button>
            {isOpen && (
              <div className="px-5 pb-4 font-poppins text-black/70 leading-relaxed">
                {item.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default function FaqSection({ faq = [] }) {
  if (faq.length === 0) return null;

  return (
    <div className="containers-min mx-auto px-4 pb-16">
      <h3 className="font-gilroy mb-6 text-center">Frequently Asked Questions</h3>
      <FaqAccordion items={faq} />
    </div>
  );
}
